import React from "react";
import { resetCookieConsent } from "@/lib/attribution";

export const PrivacyContent = () => (
  <div className="text-gray-800 space-y-5 text-base leading-relaxed">
    <h3 className="text-xl font-bold text-gray-900">Politique de confidentialité</h3>
    
    <div className="bg-gray-50 p-4 rounded-lg">
      <p className="font-semibold text-gray-900 mb-2">Responsable du traitement</p>
      <p>Ulysse Julien Berneau, Autónomo (Espagne)</p>
      <p>NIE : Y5618264E</p>
      <p>Adresse : Calle Castillejos 276, SA2A, 08025 Barcelone</p>
      <p>Contact : <a href="mailto:info@agencia-ppc.es" className="text-green-600 underline">info@agencia-ppc.es</a></p>
    </div>
    
    <div>
      <p className="font-semibold text-gray-900 mb-2">Données collectées</p>
      <p>Nom, prénom, email, téléphone, adresse, code postal, type de logement via le formulaire de contact.</p>
      <p className="mt-2">Données de mesure publicitaire : identifiant de clic Google Ads (GCLID), mot-clé de recherche, page d'arrivée, site d'origine, type de navigateur, date et heure de votre demande ou de votre clic sur notre numéro de téléphone. Nous ne conservons pas votre adresse IP.</p>
    </div>
    
    <div>
      <p className="font-semibold text-gray-900 mb-2">Finalité du traitement</p>
      <p>Mise en relation avec des auditeurs agréés de la Région Wallonne et réponse à vos demandes de devis.</p>
      <p className="mt-2">Mesure de l'efficacité de nos annonces Google Ads : lorsqu'une demande est jugée qualifiée, nous transmettons à Google Ads uniquement l'identifiant de clic (GCLID), la date de la demande et votre choix en matière de consentement (bandeau cookies, ou case facultative du formulaire). Votre nom, votre email et votre téléphone ne sont jamais transmis à Google.</p>
    </div>
    
    <div>
      <p className="font-semibold text-gray-900 mb-2">Base légale</p>
      <p>Votre consentement pour le traitement de votre demande via le formulaire et pour les cookies publicitaires (Google Tag Manager, Google Ads). Si vous cochez la case facultative du formulaire, votre consentement pour signaler votre demande à Google Ads afin de mesurer l'efficacité de nos annonces. Notre intérêt légitime pour mesurer, sans cookie, les clics sur notre numéro de téléphone et l'efficacité de nos annonces.</p>
    </div>
    
    <div>
      <p className="font-semibold text-gray-900 mb-2">Destinataires des données</p>
      <p>Auditeurs partenaires agréés par la Région Wallonne. En tant qu'apporteur d'affaires, nous pouvons recevoir une commission qui n'affecte en aucun cas le prix proposé au client.</p>
      <p className="mt-2">Google Ireland Limited (Google Ads), uniquement pour l'identifiant de clic et la date de conversion. Google peut traiter ces données hors de l'Union européenne, encadré par les clauses contractuelles types de la Commission européenne.</p>
    </div>
    
    <div>
      <p className="font-semibold text-gray-900 mb-2">Cookies</p>
      <p>Les cookies Google Ads ne sont déposés que si vous cliquez sur « Accepter ». Si vous refusez ou n'avez pas encore choisi, aucun cookie publicitaire n'est déposé et votre identifiant de clic n'est pas enregistré sur votre appareil : il est seulement gardé le temps de votre visite.</p>
      <button type="button" onClick={resetCookieConsent} className="mt-2 text-green-600 underline hover:text-green-700" data-testid="privacy-reset-cookies-btn">Modifier mon choix de cookies</button>
    </div>
    
    <div>
      <p className="font-semibold text-gray-900 mb-2">Durée de conservation</p>
      <p>Vos données sont conservées pendant une durée maximale de 3 ans à compter de votre dernière interaction avec nos services. Les statistiques de visites sont supprimées après 90 jours.</p>
    </div>
    
    <div>
      <p className="font-semibold text-gray-900 mb-2">Vos droits (RGPD)</p>
      <p>Conformément au Règlement Général sur la Protection des Données, vous disposez des droits suivants : accès, rectification, effacement, limitation, portabilité et opposition.</p>
      <p className="mt-2">Pour exercer ces droits, contactez-nous à : <a href="mailto:info@agencia-ppc.es" className="text-green-600 underline">info@agencia-ppc.es</a></p>
      <p className="mt-2">Vous pouvez retirer votre consentement à tout moment et introduire une réclamation auprès de l'Autorité de protection des données (<a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer" className="text-green-600 underline">autoriteprotectiondonnees.be</a>).</p>
    </div>
  </div>
);
